module.exports = __webpack_public_path__ + "static/img/cinema-11.70abc29.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new-img/png-img/cinema-11.png
// module id = 1212
// module chunks = 173